import React from 'react'
import { Provider } from 'react-redux'
import { ErrorBoundary } from '../components/ErrorBoundary'
import store, { history } from '../store'
import { Routes } from './Routes'
import { ConnectedRouter } from 'connected-react-router'
import ScrollToTop from '../components/ScrollToTop'

export default function App() {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <ConnectedRouter history={history}>
          <ScrollToTop />
          <Routes />
        </ConnectedRouter>
      </ErrorBoundary>
    </Provider>
  )
}
